import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid/Grid";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles({
    grid: {
        width: 250,
        marginLeft: 20,
    },
    formControl: {
        width: 80
    },
    to: {
        marginLeft: 30,
        marginRight: 30,
        marginTop: 20,
    }
});

export default function YearDesktop(props) {

    const [open, setOpen] = React.useState(false);

    const [counter, setCounter] = React.useState(0);

    const classes = useStyles();

    const params = props.filter.params;

    const filter = props.filter;

    const fixOrder = () => {
        if (params.minYear && params.maxYear) {
            if (params.minYear > params.maxYear) {
                const minYear = params.minYear;
                params.minYear = params.maxYear;
                params.maxYear = minYear;
            }
        }
    };

    const handleMinYearChange = (e) => {
        params.minYear = +e.target.value;
        if (!params.minYear || params.minYear === params.minYearLimit) {
            params.minYear = null
        }
        fixOrder();
        filter.dispatchFilter();
        render();
    };

    const handleMaxYearChange = (e) => {
        params.maxYear = +e.target.value;
        if (!params.maxYear || params.maxYear === params.maxYearLimit) {
            params.maxYear = null
        }
        fixOrder();
        filter.dispatchFilter();
        render();
    };

    const handleOpenClick = () => {
        setOpen(!open);
    };

    const render = () => {
        setCounter(counter + 1);
    };

    const years = [];
    for (let i=params.minYearLimit;i<=params.maxYearLimit; i++) {
        years.push(i);
    }

    const minYear = params.minYear === null ? years[0] : params.minYear;
    const maxYear = params.maxYear === null ? years[years.length-1] : params.maxYear;

    return (<>
        <div className={props.classes.block}>
            <div className={props.classes.opener} onClick={handleOpenClick}>
                {open ? <RemoveIcon/> : <AddIcon/>}
            </div>
            <div className={props.classes.blockHeader} onClick={handleOpenClick}><Typography><b>Year</b></Typography></div>
            {open ? <div className={props.classes.makes}><div className={props.classes.makesCont}>
                <Grid container className={classes.grid}>
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="min-year">Min</InputLabel>
                            <Select
                                native
                                value={minYear}
                                onChange={handleMinYearChange}
                                inputProps={{
                                    name: 'min',
                                    id: 'min-year',
                                }}
                            >
                                <option aria-label="Any" value="" />
                                {years.map(year => {
                                    return <option value={year}>{year}</option>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <div className={classes.to}><Typography>to</Typography></div>
                    </Grid>
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="max-year">Max</InputLabel>
                            <Select
                                native
                                value={maxYear}
                                onChange={handleMaxYearChange}
                                inputProps={{
                                    name: 'max',
                                    id: 'max-year',
                                }}
                            >
                                <option aria-label="Any" value="" />
                                {years.map(year => {
                                    return <option value={year}>{year}</option>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </div></div> : null}
        </div>
    </>)
}